export const FETCH_LISTING_SUCCESS = 'FETCH_LISTING_SUCCESS';
export const FETCH_LISTING_FAILURE = 'FETCH_LISTING_FAILURE';

export const SUBMIT_PROGRESS_SUCCESS = 'SUBMIT_PROGRESS_SUCCESS';
export const SUBMIT_PROGRESS_FAILURE = 'SUBMIT_PROGRESS_FAILURE';

export const SET_IS_FETCHING = 'SET_IS_FETCHING';
export const SET_IS_SAVING = 'SET_IS_SAVING';